'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'face-grin-beam';
var width = 512;
var height = 512;
var aliases = [128516,"grin-beam"];
var unicode = 'f582';
var svgPathData = ['M32 256a224 224 0 1 0 448 0 224 224 0 1 0 -448 0zm70.5 61.3c-3.4-11.7 8.4-21 20-17.3 39.9 12.8 85.3 20 133.5 20s93.6-7.2 133.5-20c11.6-3.7 23.4 5.6 20 17.3-19.5 66.3-80.9 114.7-153.5 114.7S122 383.6 102.5 317.3zM112 218c0-35.3 28.7-64 64-64s64 28.7 64 64c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 8.8-7.2 16-16 16s-16-7.2-16-16zm160 0c0-35.3 28.7-64 64-64s64 28.7 64 64c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 8.8-7.2 16-16 16s-16-7.2-16-16z', 'M480 256a224 224 0 1 0 -448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm256 96c-38 0-74.5-4.2-108.5-12 22.7 36.1 62.8 60 108.5 60s85.8-23.9 108.5-60c-34 7.8-70.5 12-108.5 12zm153.5-34.7C390 383.6 328.6 432 256 432S122 383.6 102.5 317.3c-3.4-11.7 8.4-21 20-17.3 39.9 12.8 85.3 20 133.5 20s93.6-7.2 133.5-20c11.6-3.7 23.4 5.6 20 17.3zM176 186c-17.7 0-32 14.3-32 32 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-35.3 28.7-64 64-64s64 28.7 64 64c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-17.7-14.3-32-32-32zm128 32c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-35.3 28.7-64 64-64s64 28.7 64 64c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-17.7-14.3-32-32-32s-32 14.3-32 32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceGrinBeam = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;